const raw = (process.env.REACT_APP_ENABLE_TRAINS || "").toLowerCase();

export const ENABLE_TRAINS = raw === "true";